<template>

    <!-- Modal Component -->
    <Modal
      :title="$t('create_category')"
      modalId="create-modal"
      @submit="submitCategory"
      @cancel="resetForm"
    >
      <form @submit.prevent="submitCategory">
        <div class="mb-3">
          <label class="form-label">{{ $t('category_name') }} <span class="">*</span></label>
          <input
            type="text"
            v-model="category.node"
            class="form-control"
          />
          <div v-if="errors.node" class="text-danger mt-2">
            <span>{{ errors.node }}</span>
          </div>
        </div>
        <div v-if="errorMessage" class="text-danger mt-2">{{ errorMessage }}</div>
      </form>
    </Modal>
  </template>

  <script>
  import Modal from '@/components/common/Modal.vue'; // Import the Modal component
  import apiUrls from '@/urls';
  import {useToast} from "vue-toastification";

  export default {
    components: {
      Modal,
    },
    data() {
      return {
        category: {
          node: '',
        },
        errorMessage: "",
        errors: {}
      };
    },

    setup() {
      const toast = useToast()
      return {toast}
    },

    methods: {
      async submitCategory() {
        try {
          const formData = new FormData();
          Object.keys(this.category).forEach((key) => {
            formData.append(key, this.category[key]);
          });
          // Send API request
          const response = await this.$axios.post(apiUrls.supplier_head.post, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          this.toast.success('Supplier category successfully created!')

          // Close modal after success
          const modal = document.getElementById("create-modal");
          const modalInstance = bootstrap.Modal.getInstance(modal);
          if (modalInstance) modalInstance.hide();

          // Emit event to update parent component
          this.$emit("create_success", response.data);

          this.resetForm();
        } catch (error) {
          this.errors = {};
          this.errorMessage = "";

          if (error.response) {
            // Backend field-specific errors
            if (error.response.data?.errors) {
              const backendErrors = error.response.data.errors;

              // Assign to Vue errors object (keep as array)
              Object.keys(backendErrors).forEach(key => {
                this.errors[key] = backendErrors[key];
              });
            }

            // Backend general error message (optional)
            if (error.response.data?.error) {
              this.errorMessage = error.response.data.error;
            }

          } else if (error.request) {
            this.errorMessage = "No response from server. Check network.";

          } else {
            this.errorMessage = error.message;
          }
        }
      },
      resetForm() {
      // Reset form fields and errors
      this.category.node = "";
      this.errors = {};
      this.errorMessage = "";
    }
  },
  };
  </script>
